
const SYMBOL = {
  'USD': '$',
  'EUR': '€',
  'GBP': '£',
  'JPY': '¥',
  'ILS': '₪',
  'CAD': '$',
};

const repr = (value) => {

  const symbol = SYMBOL[value];

  if (symbol) {
    return symbol;
  }

  return value;
};

const currency = {
  repr,
};

export default currency;